import clsx from 'clsx';

interface SignupCardProps {
  children: React.ReactNode;
}

export const SignupCard = ({ children }: SignupCardProps) => {
  return (
    <div className="flex flex-col md:flex-row w-full min-h-screen">
      <div className="w-[95%] min-w-[300px] md:max-w-[500px] bg-neutral-600 p-4 lg:p-8 shadow-md mx-auto md:mx-0">
        <div className="flex justify-between items-center">
          <img
            src="/assets/logo-white.png"
            alt="Circle"
            className={clsx('h-10 animate-fade-in-up')}
          />

          <a
            href="https://fluents.ai/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium opacity-100 text-neutral-0 flex md:hidden"
          >
            Contact Us
          </a>
        </div>

        <div className="pt-[60px] md:pt-[20px] overflow-auto block">
          {children}
        </div>
      </div>

      <div className="hidden md:flex flex-col items-center p-2 w-full">
        <div
          className={clsx(
            'flex justify-end xl:mt-10 xl:mr-10 xl:mb-10 xl:h-10 animate-fade-in-up z-10 w-full',
          )}
        >
          <a
            href="https://fluents.ai/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium opacity-100 text-neutral-0"
          >
            Contact Us
          </a>
        </div>

        <div className="w-full text-center bg-neutral-0 p-6 xl:p-8 rounded-lg mx-1 xl:mx-2 hidden md:block max-w-[40rem]">
          <h2 className="text-primary mb-2 text-left">
            The Power of Voice AI Sales Agents
          </h2>
          <p className="text-neutral-600 mb-6 text-left">
            Voice AI Sales Agents automate your sales calls, qualify leads 24/7,
            and boost your customer experience with instant multilingual
            interactions.
          </p>

          <h2 className="text-primary mb-2 text-left">Free Trial Includes</h2>
          <ul className="text-left text-neutral-700 space-y-4 mb-6">
            <li>
              <span className="font-semibold">14-Day Free Trial</span>
              <br />
              <span className="block">
                Enjoy full access, risk-free. No credit card required.
              </span>
            </li>
            <li>
              <span className="font-semibold">Instant Setup</span>
              <br />
              <span className="block">
                Quickly activate your first Voice AI Sales Agent and start
                testing today.
              </span>
            </li>
            <li>
              <span className="font-semibold">Book Your Free Demo</span>
              <br />
              <span className="block">
                Schedule a personalized demo with our expert team to maximize
                results.
              </span>
            </li>
            <li>
              <span className="font-semibold">Dedicated Support</span>
              <br />
              <span className="block">
                Receive responsive email support throughout your trial.
              </span>
            </li>
            <li>
              <span className="font-semibold">Unlock Immediate Benefits:</span>
              <br />
              <span className="block">
                - Automate lead qualification and sales calls
              </span>
              <span className="block">
                - Enhance customer experience with multilingual capabilities
              </span>
              <span className="block">
                - Increase sales efficiency instantly
              </span>
            </li>
          </ul>

          <a
            href="https://calendly.com/florent-fluents/fluents-ai-demo-voice-ai"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-primary text-neutral-0 font-semibold py-4 px-6 rounded-md hover:bg-primary/90 transition cursor-pointer active:bg-primary/80 block"
          >
            Prefer a Walkthrough? Book a 1:1 Demo
          </a>
        </div>
      </div>
    </div>
  );
};
